/**
 * Herleitung eines Tagespreises als Kasten (Board „Verlauf · Entscheidungen“): gleiche Zeilen im
 * Verlauf und im V&V-Tagesdetail, darunter die Herleitung des Mindestaufenthalts.
 */
import type { PricingMinimumStayExplanation } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { MinimumStayDecisionExplanation } from './MinimumStayDecisionExplanation';
import { priceDerivation, type DerivationSource } from './priceDerivationModel';

export function PriceDerivation({
  source,
  minimumStay,
  className = 'bg-card',
}: {
  source: DerivationSource;
  minimumStay?: PricingMinimumStayExplanation | null;
  /** Fläche des Kastens, passend zur Umgebung. */
  className?: string;
}) {
  const derivation = priceDerivation(source);
  return (
    <section className={cn('flex flex-col gap-1.5 rounded-lg p-3.5', className)}>
      <h3 className="text-[13px] font-bold">{derivation.title}</h3>
      <ul className="flex flex-col gap-1">
        {derivation.lines.map((line) => (
          <li key={line} className="text-ink text-xs leading-normal">
            {line}
          </li>
        ))}
      </ul>
      {derivation.code && (
        <code className="text-ink-soft break-all font-mono text-[11px]">{derivation.code}</code>
      )}
      <MinimumStayDecisionExplanation explanation={minimumStay} />
    </section>
  );
}
